import styled from "styled-components"

import { ReactNode } from "react";
import { Logo } from "../Logo";
import React from "react";

const HeaderWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: baseline;
    padding: 10px 20px;
    background-color: #f5f5f5;
    gap: 60px;
    opacity: 0.95;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    z-index: 1000;
`

export const Header = ({ children }: { children: ReactNode }) => {

    return (
        <HeaderWrapper>
            <Logo />
            {children}
        </HeaderWrapper>
    )
}